module.exports = __webpack_public_path__ + "img/IT.e9f8c269.svg";